'use strict';

angular.module('atex.dam').controller('DamJobTemplatesController', ['$scope','ContentService','DamNotificationService','$translate',
  function ($scope,ContentService,DamNotificationService, $translate) {

    $translate(['__GENERIC_ERROR_MSG__', '__OPERATION_COMPLETED_SUCCESSFULLY__']).then(function (translations) {
      $scope.message = {};

      $scope.message.error = translations.__GENERIC_ERROR_MSG__;
      $scope.message.success = translations.__OPERATION_COMPLETED_SUCCESSFULLY__;
    });

    ContentService.getContent({id: 'atex.TemplatesList'}).then(function (content) {
      $scope.templates = atex.onecms.ObjectUtils.getByPath(content.data.aspects, 'contentData/data/templates') || [];
    }).then(null, function (error) {
      var message =  $scope.message.error + " (" + error.cause + ")";
      DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
    });

    $scope.icons = {
      "article": {"icon": "fa fa-pencil", "label": "Article", "value": "article"},
      "image": {
        "icon": "fa fa-camera", "label": "Image",
        "value": "image"
      },
      "images": {"icon": "fa fa-folder", "label": "Images", "value": "images"},
      "video": {"icon": "fa fa-video-camera", "label": "Video", "value": "video"}
    };

    $scope.get = function (type) {
      var conf = $scope.icons[type];
      return (conf) ? conf.icon : "fa fa-warning";
    };

    $scope.delete = function (key) {
      $scope.templates.splice(key, 1);
    };

    $scope.create = function () {
      $scope.templates.push(empty());
    };

    $scope.remove = function (index) {
      var template = getTemplate(index);
      if (template) {
        template.tasks.splice(-1, 1);
      }
    };

    $scope.add = function (index, type) {
      var template = getTemplate(index);
      if (template) {
        template.tasks.push(type);
      }
    };

    $scope.doSave = function () {
      ContentService.getContent({id: 'atex.TemplatesList'}).then(function (content) {
        content.data.aspects.contentData.data.templates = $scope.templates;

        var json = angular.toJson(content.data);
        var cleanData = angular.fromJson(json);
        delete cleanData.aspects.contentData.data.templates_element_types;

        if (cleanData.aspects.contentData.data.templates) {
          cleanData.aspects.contentData.data.templates.forEach(function (template) {
            delete template.tasks_element_types;
          });
        }

        var updateInfo = {id: content.id, data: cleanData, revision: content.revision};
        ContentService.updateContent(updateInfo).then(function (response) {
          DamNotificationService.addNotification(atex.dam.Notification({type: 'success', message: $scope.message.success}), false);
          $scope.$parent.doCancel();
        }).then(null, function (error) {
          var message =  $scope.message.error + " (" + error.cause + ")";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });
      }).then(null, function (error) {
        var message =  $scope.message.error + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
      });
    };

    function getTemplate(id) {
      var object = _.find($scope.templates, function (template) {
        return template.id === id;
      });

      return object;
    }

    function empty() {
      return {"id": guid(), "name": "", "tasks": []};
    }

    function guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }

      return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
    }
  }]);